export default {
    address: 'Adresse',
    zipcode: 'Postleitzahl',
    city: 'Stadt',
    street: 'Straße',
    houseNumber: 'Hausnummer',
    country: 'Land',
    reasonForAbroadInfo: 'Sollte ihre Veranstaltung im Ausland stattfinden, begründen Sie bitte hier ihre Entscheidung und nehmen Sie Kontakt zu uns auf.',
    reasonForAbroad: 'Begründung',
    customAddress: 'Ausländisch oder manuell',
    searchAddress: 'Adresssuche DE',
    searchPlaceholder: 'Suche nach Postleitzahl, Stadt, Straße',
    searchZipcode: 'Suche nach Postleitzahl',
    searchCity: 'Suche nach Stadt',
    noSearchResults: 'Es wurde kein Eintrag zu dieser Suche gefunden. Möglicherweise wurde Ihre Straße noch nicht erfasst. Klicken Sie hier, um die Adresse manuell einzugeben.',
    selectExistingStreet: 'Existierende Straße wählen',
    noCountryResults: 'Es wurde kein Land zu dieser Suche gefunden. Möglicherweise gibt es keine KJP-Förderung. Bei Fragen melden Sie sich bei der Geschäftsstelle:\n\n+49 511 1215-166\n+49 511 1215-159',
}